import React from 'react'
import imgStampingCapabilities from "../../imagens/stamping/imgStampingCapabilities.png"
import { Link } from 'react-router-dom'
import logoToolingsPT from "../../imagens/logos/logoToolings.png"
import logoToolingsEN from "../../imagens/logos/logoToolingsEn.png"
import imgMoldes from "../../imagens/moldes/imgMolde.png"
import "./toolingAndManufacturing.css"

import { useTranslation } from "react-i18next";

const ToolingAndManufacturing = () => {
    const { t, i18n } = useTranslation();
    const language = i18n.language;

    return (
        <div>
            <div className="text-start mb-2 ms-2">
                <img
                    className="img-fluid img-custom-size"
                    src={language === "en" ? logoToolingsEN : logoToolingsPT}
                    alt="Capabilities Logo"
                />
            </div>

            <div className="container-fluid p-5">
                <div className="customrow1 w-100">
                    <div className="custom-width1 mb-4 hover-custom">
                        <Link className="text-decoration-none" to="/Capabilities/Engineering/StampingTool">
                            <img src={imgStampingCapabilities} className="img-fluid" alt="Stamping Capabilities" />
                            <h2 className="textCapabilities text-wrap mt-2 fs-md-5">
                                {t("tooling.stamping")}
                            </h2>
                        </Link>
                    </div>

                    <div className="custom-width1 mb-4 hover-custom">
                        <Link className="text-decoration-none" to="/Capabilities/Engineering/Molds">
                            <img src={imgMoldes} className="img-fluid" alt="Injection molds" />
                            <h2 className="textCapabilities text-wrap mt-2 fs-md-5">
                                {t("tooling.molds")}
                            </h2>
                        </Link>
                    </div>
                </div>
            </div>

            <div className="text-center my-4">
                <Link to="/Capabilities">
                    <button className="buttonCapabilities">
                        {t("common.backToCapabilities")}
                    </button>
                </Link>
            </div>
        </div>
    )
}

export default ToolingAndManufacturing
